import React from "react"
import PropTypes from "prop-types"

export default function Icon({
  color,
  className,
  fillColor,
  icon,
  width,
  height,
  strokeWidth,
  title,
}) {
  switch (icon) {
    default:
    case "arrow-left":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Left Arrow"}</title>}
          <path
            d="M15.8334 10H4.16675"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.0001 15.8333L4.16675 9.99999L10.0001 4.16666"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "arrow-right":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Right Arrow"}</title>}
          <path
            d="M4.16675 10H15.8334"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4.16666L15.8333 9.99999L10 15.8333"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "check-circle":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Check Circle"}</title>}
          <path
            d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 4L12 14.01L9 11.01"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "edit":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Edit"}</title>}
          <g clipPath="url(#clip0_183_2248)">
            <path
              d="M9.16675 3.33334H3.33341C2.89139 3.33334 2.46746 3.50893 2.1549 3.82149C1.84234 4.13405 1.66675 4.55798 1.66675 5V16.6667C1.66675 17.1087 1.84234 17.5326 2.1549 17.8452C2.46746 18.1577 2.89139 18.3333 3.33341 18.3333H15.0001C15.4421 18.3333 15.866 18.1577 16.1786 17.8452C16.4912 17.5326 16.6667 17.1087 16.6667 16.6667V10.8333"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.4167 2.08333C15.7483 1.75181 16.1979 1.56557 16.6667 1.56557C17.1356 1.56557 17.5852 1.75181 17.9167 2.08333C18.2483 2.41485 18.4345 2.86449 18.4345 3.33333C18.4345 3.80217 18.2483 4.25181 17.9167 4.58333L10.0001 12.5L6.66675 13.3333L7.50008 10L15.4167 2.08333Z"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_183_2248">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case "key":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Key"}</title>}
          <path
            d="M21 2L19 4M19 4L22 7L18.5 10.5L15.5 7.5M19 4L15.5 7.5M11.39 11.61C11.9064 12.1195 12.3168 12.726 12.5978 13.3948C12.8787 14.0635 13.0246 14.7813 13.0271 15.5066C13.0295 16.232 12.8884 16.9507 12.6119 17.6213C12.3355 18.2919 11.9291 18.9012 11.4162 19.4141C10.9033 19.9271 10.294 20.3334 9.62333 20.6099C8.95271 20.8864 8.23403 21.0275 7.50866 21.025C6.7833 21.0226 6.06557 20.8767 5.39682 20.5958C4.72807 20.3148 4.1215 19.9043 3.61203 19.388C2.61016 18.3507 2.05579 16.9614 2.06832 15.5193C2.08085 14.0772 2.65928 12.6977 3.67903 11.678C4.69877 10.6583 6.07824 10.0798 7.52032 10.0673C8.96241 10.0548 10.3517 10.6091 11.389 11.611L11.39 11.61ZM11.39 11.61L15.5 7.5"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "search":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Search"}</title>}
          <path
            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 17.5L13.875 13.875"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    case "settings":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Settings"}</title>}
          <g clipPath="url(#clip0_183_2216)">
            <path
              d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.1666 12.5C16.0557 12.7513 16.0226 13.0302 16.0716 13.3005C16.1206 13.5708 16.2495 13.8203 16.4416 14.0167L16.4916 14.0667C16.6465 14.2214 16.7695 14.4053 16.8534 14.6076C16.9372 14.8099 16.9804 15.0268 16.9804 15.2458C16.9804 15.4649 16.9372 15.6817 16.8534 15.8841C16.7695 16.0864 16.6465 16.2702 16.4916 16.425C16.3368 16.58 16.153 16.7029 15.9507 16.7868C15.7483 16.8706 15.5314 16.9138 15.3124 16.9138C15.0934 16.9138 14.8765 16.8706 14.6742 16.7868C14.4719 16.7029 14.288 16.58 14.1333 16.425L14.0833 16.375C13.8869 16.1829 13.6374 16.054 13.3671 16.005C13.0967 15.956 12.8179 15.9891 12.5666 16.1C12.3201 16.2056 12.1099 16.381 11.9618 16.6046C11.8138 16.8282 11.7343 17.0902 11.7333 17.3583V17.5C11.7333 17.942 11.5577 18.3659 11.2451 18.6785C10.9325 18.9911 10.5086 19.1667 10.0666 19.1667C9.62456 19.1667 9.20064 18.9911 8.88807 18.6785C8.57551 18.3659 8.39992 17.942 8.39992 17.5V17.425C8.39347 17.1492 8.30418 16.8817 8.14368 16.6572C7.98317 16.4328 7.75886 16.2619 7.49992 16.1667C7.24857 16.0557 6.96976 16.0226 6.69943 16.0717C6.4291 16.1207 6.17965 16.2495 5.98325 16.4417L5.93325 16.4917C5.77846 16.6466 5.59465 16.7696 5.39232 16.8534C5.18999 16.9373 4.97311 16.9805 4.75409 16.9805C4.53506 16.9805 4.31818 16.9373 4.11585 16.8534C3.91352 16.7696 3.72971 16.6466 3.57492 16.4917C3.41996 16.3369 3.29703 16.1531 3.21315 15.9507C3.12928 15.7484 3.08611 15.5315 3.08611 15.3125C3.08611 15.0935 3.12928 14.8766 3.21315 14.6743C3.29703 14.4719 3.41996 14.2881 3.57492 14.1333L3.62492 14.0833C3.81703 13.8869 3.94591 13.6375 3.99492 13.3672C4.04394 13.0968 4.01085 12.818 3.89992 12.5667C3.79428 12.3202 3.61888 12.11 3.39531 11.9619C3.17173 11.8139 2.90974 11.7344 2.64159 11.7333H2.49992C2.05789 11.7333 1.63397 11.5577 1.32141 11.2452C1.00885 10.9326 0.833252 10.5087 0.833252 10.0667C0.833252 9.62463 1.00885 9.20071 1.32141 8.88815C1.63397 8.57559 2.05789 8.4 2.49992 8.4H2.57492C2.85075 8.39354 3.11826 8.30426 3.34267 8.14375C3.56708 7.98325 3.73802 7.75894 3.83325 7.5C3.94418 7.24865 3.97727 6.96983 3.92826 6.6995C3.87924 6.42918 3.75037 6.17973 3.55825 5.98333L3.50825 5.93333C3.35329 5.77854 3.23036 5.59473 3.14649 5.3924C3.06261 5.19007 3.01944 4.97319 3.01944 4.75416C3.01944 4.53514 3.06261 4.31826 3.14649 4.11593C3.23036 3.9136 3.35329 3.72978 3.50825 3.575C3.66304 3.42003 3.84685 3.2971 4.04918 3.21323C4.25152 3.12935 4.46839 3.08618 4.68742 3.08618C4.90644 3.08618 5.12332 3.12935 5.32565 3.21323C5.52798 3.2971 5.7118 3.42003 5.86659 3.575L5.91659 3.62499C6.11298 3.81711 6.36243 3.94598 6.63276 3.995C6.90309 4.04401 7.18191 4.01092 7.43325 3.89999H7.49992C7.74639 3.79436 7.9566 3.61896 8.10466 3.39538C8.25273 3.17181 8.33218 2.90982 8.33325 2.64166V2.49999C8.33325 2.05797 8.50885 1.63404 8.82141 1.32148C9.13397 1.00892 9.55789 0.833328 9.99992 0.833328C10.4419 0.833328 10.8659 1.00892 11.1784 1.32148C11.491 1.63404 11.6666 2.05797 11.6666 2.49999V2.57499C11.6677 2.84315 11.7471 3.10514 11.8952 3.32872C12.0432 3.55229 12.2534 3.72769 12.4999 3.83333C12.7513 3.94426 13.0301 3.97735 13.3004 3.92833C13.5707 3.87932 13.8202 3.75044 14.0166 3.55833L14.0666 3.50833C14.2214 3.35337 14.4052 3.23044 14.6075 3.14656C14.8098 3.06269 15.0267 3.01952 15.2458 3.01952C15.4648 3.01952 15.6817 3.06269 15.884 3.14656C16.0863 3.23044 16.2701 3.35337 16.4249 3.50833C16.5799 3.66312 16.7028 3.84693 16.7867 4.04926C16.8706 4.25159 16.9137 4.46847 16.9137 4.6875C16.9137 4.90652 16.8706 5.1234 16.7867 5.32573C16.7028 5.52806 16.5799 5.71187 16.4249 5.86666L16.3749 5.91666C16.1828 6.11306 16.0539 6.36251 16.0049 6.63284C15.9559 6.90317 15.989 7.18198 16.0999 7.43333V7.5C16.2056 7.74647 16.381 7.95668 16.6045 8.10474C16.8281 8.2528 17.0901 8.33226 17.3583 8.33333H17.4999C17.9419 8.33333 18.3659 8.50892 18.6784 8.82148C18.991 9.13404 19.1666 9.55797 19.1666 10C19.1666 10.442 18.991 10.8659 18.6784 11.1785C18.3659 11.4911 17.9419 11.6667 17.4999 11.6667H17.4249C17.1568 11.6677 16.8948 11.7472 16.6712 11.8953C16.4476 12.0433 16.2722 12.2535 16.1666 12.5Z"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_183_2216">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case "thumbs-up":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Thumbs Up"}</title>}
          <g clipPath="url(#clip0_183_2355)">
            <path
              d="M5.83341 9.16667L9.16675 1.66667C9.82979 1.66667 10.4657 1.93006 10.9345 2.3989C11.4034 2.86774 11.6667 3.50363 11.6667 4.16667V7.5H16.3834C16.625 7.49726 16.8643 7.54709 17.0847 7.64601C17.3051 7.74494 17.5014 7.89061 17.66 8.07293C17.8185 8.25525 17.9355 8.46985 18.0029 8.70188C18.0702 8.9339 18.0863 9.1778 18.0501 9.41667L16.9001 16.9167C16.8398 17.3141 16.6379 17.6763 16.3317 17.9367C16.0254 18.197 15.6354 18.3379 15.2334 18.3333H5.83341M5.83341 9.16667V18.3333M5.83341 9.16667H3.33341C2.89139 9.16667 2.46746 9.34226 2.1549 9.65482C1.84234 9.96738 1.66675 10.3913 1.66675 10.8333V16.6667C1.66675 17.1087 1.84234 17.5326 2.1549 17.8452C2.46746 18.1577 2.89139 18.3333 3.33341 18.3333H5.83341"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_183_2355">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case "x":
      return (
        <svg
          className={`icon${className ? ` ${className}` : ""}`}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title !== "" && <title>{title || "Close"}</title>}
          <path
            d="M15 5L5 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 5L15 15"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
  }
}

Icon.propTypes = {
  /** Class name of icon */
  className: PropTypes.string,
  /**
   * Sets stroke color of icon
   */
  color: PropTypes.string,
  /**
   * Sets fill color of icon
   */
  fillColor: PropTypes.string,
  /**
   * Name of icon
   */
  icon: PropTypes.string.isRequired,
  /**
   * Sets width of icon
   */
  width: PropTypes.number,
  /**
   * Sets height of icon
   */
  height: PropTypes.number,
  /**
   * Sets stroke width of icon
   */
  strokeWidth: PropTypes.number,
  /**
   * Sets title of icon for accessibility
   */
  title: PropTypes.string,
}

Icon.defaultProps = {
  color: "#1a202c", // Orca Grey 8
  height: 20,
  width: 20,
  strokeWidth: 1,
}
